import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["temp", "query"];

  // 				Needs the following markup to work:
  // <div class="bibliotek-search cf" data-turbo="false">
  // 	<form data-controller="oria" class="content-forms" id="simple"
  // 		action="https://bibsys-wl.primo.exlibrisgroup.com/discovery/search"
  // 		enctype="application/x-www-form-urlencoded; charset=utf-8" method="get">
  // 		<input name="vid" type="hidden" value="47BIBSYS_KHIO:KHIO" />
  // 		<input name="search_scope" type="hidden" value="MyInst_and_CI" />
  // 		<input name="lang" type="hidden" value="no" />
  // 		<input name="tab" type="hidden" value="default_slot" />
  // 		<label class="input-container">
  // 			<span>Søk i <a
  // 					href="https://bibsys-wl.primo.exlibrisgroup.com/discovery/search?vid=47BIBSYS_KHIO:KHIO&lang=no">Oria</a>
  // 			</span>
  // 			<input type="hidden" name="query" id="primoQuery" data-oria-target="query" />
  // 			<input id="primoQueryTemp" type="text" size="25"
  // 				placeholder="Søk etter forfatter, tittel, emne, ord" data-oria-target="temp" />
  // 		</label>
  // 		<input title="Søk" class="large-btn" id="submit" type="submit" alt="Søk" value="Søk"
  // 			data-action="oria#searchPrimo:prevent" />
  // 	</form>
  // </div>

  searchPrimo() {
    this.queryTarget.value = `any,contains,${this.tempTarget.value}`;
    this.element.requestSubmit();
  }
}
